/* Gut Essentials Duo hero behaviour: flavour -> variant by SKU, live price, add to cart (themeRefreshCart), sticky bar, gallery thumbs, lightbox, video. 28 Oct 2026. */
(function () {
  'use strict';
  function init(root) {
  if (!root || root.__gd) return;
  root.__gd = true;

  var variants = {};
  try { variants = JSON.parse(root.querySelector('[data-gd-variants]').textContent); } catch (e) {}
  var pattern = (root.getAttribute('data-sku-pattern') || 'GUTDUO-[A]-[B]').toUpperCase();
  var soldLabel = root.getAttribute('data-soldout-label') || 'Sold out';
  var inr = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
  function money(p) { return '₹ ' + inr.format(Math.round(p / 100)); }
  var inr2 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money2(p) { return '₹ ' + inr2.format(p / 100); }
  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  var optsA = $$('[data-gd-opt="a"]'), optsB = $$('[data-gd-opt="b"]');
  var atc = $('[data-gd-atc]'), atcLabel = $('[data-gd-atc-label]'), atcText = atcLabel ? atcLabel.textContent : '';
  var sticky = $('[data-gd-sticky]'), stickyBtn = $('[data-gd-sticky-atc]'), stickyLabel = $('[data-gd-sticky-label]'), stickyText = stickyLabel ? stickyLabel.textContent : '';
  var err = $('[data-gd-error]');
  var state = { a: null, b: null, v: null };

  function skuFor(a, b) { return pattern.replace('[A]', String(a || '').toUpperCase()).replace('[B]', String(b || '').toUpperCase()); }
  function code(el) { return el ? el.getAttribute('data-code') : ''; }

  function markSoldOut() {
    optsA.forEach(function (o) {
      var any = optsB.some(function (b) { var v = variants[skuFor(code(o), code(b))]; return v && v.available; });
      o.classList.toggle('is-soldout', !any);
    });
    optsB.forEach(function (o) {
      var v = variants[skuFor(code(state.a), code(o))];
      o.classList.toggle('is-soldout', !(v && v.available));
    });
  }

  function render(pushUrl) {
    state.v = variants[skuFor(code(state.a), code(state.b))] || null;
    optsA.concat(optsB).forEach(function (o) {
      var on = o === state.a || o === state.b;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    markSoldOut();
    var v = state.v, ok = !!(v && v.available);
    if (v) {
      var compare = v.compare > v.price ? v.compare : 0;
      var row = $('[data-gd-mrp-row]'); if (row) row.hidden = !compare;
      var c = $('[data-gd-compare]'); if (c && compare) c.textContent = money(compare);
      var p = $('[data-gd-price]'); if (p) p.textContent = money(v.price);
      var s = $('[data-gd-save]'); if (s) s.hidden = !compare;
      var sa = $('[data-gd-save-amt]'); if (sa && compare) sa.textContent = money(compare - v.price);
      var sm = $('[data-gd-sticky-mrp]'); if (sm) sm.hidden = !compare;
      var sc = $('[data-gd-sticky-compare]'); if (sc && compare) sc.textContent = money2(compare);
      var sp = $('[data-gd-sticky-price]'); if (sp) sp.textContent = money2(v.price);
      var ss = $('[data-gd-sticky-save]'); if (ss) ss.hidden = !compare;
      var ssa = $('[data-gd-sticky-save-amt]'); if (ssa && compare) ssa.textContent = money(compare - v.price);
      if (pushUrl && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    }
    [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
    if (atcLabel) atcLabel.textContent = ok ? atcText : soldLabel;
    if (stickyLabel) stickyLabel.textContent = ok ? stickyText : soldLabel;
  }

  function bind(list, key) {
    list.forEach(function (o) {
      o.addEventListener('click', function () { state[key] = o; showError(''); render(true); });
    });
  }
  bind(optsA, 'a'); bind(optsB, 'b');

  /* initial selection = the variant Shopify resolved (?variant= or first available) */
  var initial = (root.getAttribute('data-initial-sku') || '').toUpperCase();
  optsA.forEach(function (a) { optsB.forEach(function (b) { if (!state.a && skuFor(code(a), code(b)) === initial) { state.a = a; state.b = b; } }); });
  if (!state.a) state.a = optsA.filter(function (o) { return o.hasAttribute('data-default'); })[0] || optsA[0] || null;
  if (!state.b) state.b = optsB.filter(function (o) { return o.hasAttribute('data-default'); })[0] || optsB[0] || null;
  render(false);

  function showError(m) { if (!err) return; err.textContent = m || ''; err.hidden = !m; }
  function busy(on) { [atc, stickyBtn].forEach(function (b) { if (!b) return; b.disabled = on || !(state.v && state.v.available); if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); }); }

  function add() {
    if (!state.v || !state.v.available) return;
    showError(''); busy(true);
    var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: state.v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
        try { if (typeof window.oaiq === 'function') window.oaiq('measure', 'items_added', { type: 'contents' }); } catch (e) {}
        if (typeof window.themeRefreshCart === 'function') {
          window.themeRefreshCart(true);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
        }
        var drawer = document.getElementById('mini-cart');
        if (drawer && 'open' in drawer) { try { drawer.open = true; } catch (e) {} }
      })
      .catch(function (e) { showError(e.message); })
      .then(function () { busy(false); });
  }
  if (atc) atc.addEventListener('click', add);
  if (stickyBtn) stickyBtn.addEventListener('click', add);

  /* sticky bar while the main button is off screen (and the hero has been scrolled past) */
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    }).observe(atc);
  }

  /* "See the science" smooth scroll */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-gd-scroll]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (h.charAt(0) !== '#' || h.length < 2) return;
    var t = document.getElementById(h.slice(1)) || document.querySelector('[id*="' + h.slice(1).replace(/"/g, '') + '"]');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* video */
  var vw = $('[data-gd-video]');
  if (vw) {
    var vid = vw.querySelector('video');
    vw.querySelector('[data-gd-play]').addEventListener('click', function () { vid.controls = true; vw.classList.add('is-playing'); vid.play(); });
  }

  /* lightbox with prev / next (Figma 4023:18992) */
  var modal = null, lb = { list: [], i: 0 };
  var prevIco = root.getAttribute('data-lb-prev') || '', nextIco = root.getAttribute('data-lb-next') || '';
  function lbShow() {
    var z = lb.list[lb.i]; if (!z) return;
    var img = modal.querySelector('.gd-modal__panel img'), im = z.querySelector('img');
    var src = z.getAttribute('data-gd-zoom');
    if (img.getAttribute('src') !== src) { img.style.transition = 'opacity .15s ease'; img.style.opacity = '0'; img.onload = function () { img.style.opacity = '1'; }; img.src = src; }
    img.alt = im ? im.alt : '';
    modal.querySelector('[data-count]').textContent = (lb.i + 1) + ' of ' + lb.list.length;
    modal.querySelector('.gd-modal__nav').hidden = lb.list.length < 2;
  }
  function lbGo(d) { var n = lb.list.length; if (n < 2) return; lb.i = (lb.i + d + n) % n; lbShow(); }
  function ensureModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'gd-modal'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Product images');
    modal.innerHTML = '<div class="gd-modal__bg" data-x></div>' +
      '<div class="gd-modal__panel"><button type="button" class="gd-modal__x" data-x aria-label="Close">&times;</button><img alt=""></div>' +
      '<div class="gd-modal__nav"><button type="button" class="gd-modal__arrow" data-prev aria-label="Previous image"><img alt="" src="' + prevIco + '"></button>' +
      '<span data-count aria-live="polite"></span>' +
      '<button type="button" class="gd-modal__arrow gd-modal__arrow--next" data-next aria-label="Next image"><img alt="" src="' + (nextIco || prevIco) + '"></button></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) closeZoom();
      else if (e.target.closest('[data-prev]')) lbGo(-1);
      else if (e.target.closest('[data-next]')) lbGo(1);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') closeZoom();
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
    });
    var sx = 0, pimg = modal.querySelector('.gd-modal__panel img');
    pimg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    pimg.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1); }, { passive: true });
  }
  function openZoom(z) {
    ensureModal();
    var scope = z.closest('[data-gd-track]') || z.closest('.gd__gallery') || root;
    lb.list = Array.prototype.slice.call(scope.querySelectorAll('[data-gd-zoom]'));
    lb.i = Math.max(0, lb.list.indexOf(z));
    lbShow();
    modal.hidden = false; document.documentElement.classList.add('gd-modal-open');
    var x = modal.querySelector('.gd-modal__x'); if (x) x.focus();
  }
  function closeZoom() { if (modal) { modal.hidden = true; document.documentElement.classList.remove('gd-modal-open'); } }
  root.addEventListener('click', function (e) {
    var z = e.target.closest('[data-gd-zoom]');
    if (z) openZoom(z);
  });

  /* mobile thumbs: one per slide, swipeable row, fade on the right while more are hidden */
  var track = $('[data-gd-track]'), thumbs = $('[data-gd-thumbs]');
  if (track && thumbs) {
    var slides = Array.prototype.slice.call(track.children);
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gd__thumb' + (i === 0 ? ' is-active' : '');
      var im = s.querySelector('img');
      b.innerHTML = '<img alt="" loading="lazy" src="' + (im ? (im.currentSrc || im.src) : '') + '">';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      thumbs.appendChild(b);
    });
    var tb = Array.prototype.slice.call(thumbs.children), last = 0;
    function endCue() { thumbs.classList.toggle('is-end', thumbs.scrollLeft + thumbs.clientWidth >= thumbs.scrollWidth - 2); }
    thumbs.addEventListener('scroll', endCue, { passive: true }); endCue();
    track.addEventListener('scroll', function () {
      var i = Math.min(tb.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      if (i === last) return; last = i;
      tb.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = tb[i]; if (t) thumbs.scrollTo({ left: t.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }, { passive: true });
  }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-gd]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();